import { View, StyleSheet } from "react-native";
import PreviewModeBannerContainer from "../containers/adminDashboard/PreviewModeBannerContainer/PreviewModeBannerContainer";
import { usePreviewMode } from "../contexts/PreviewModeContext";

function BlankLayout({ children, flexDirection = "row" }) {
  const { isPreviewMode } = usePreviewMode();

  return (
    <View style={[styles.container, { flexDirection: "column" }]}>
      {isPreviewMode && <PreviewModeBannerContainer />}

      <View style={[styles.content, { flexDirection }]}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    maxHeight: "100vh",
    overflow: "hidden",
  },
  content: {
    flex: 1,
  },
});

export default BlankLayout;
